export type RequestStatusEnum = 'APPROVED' | 'PENDING' | 'REJECTED';

export const RequestStatusEnumValues = {
    Approved: 'APPROVED' as RequestStatusEnum,
    Pending: 'PENDING' as RequestStatusEnum,
    Rejected: 'REJECTED' as RequestStatusEnum,
};
